
























































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import "../BudgetView.scss";
import {Ax} from "@/utils";
import JournalTable from "@/modules/budget/components/Journal.vue";
import store from "@/services/store";

export interface Report520 {
    file_name: string;
    report_date: string;
    region: string;
    budget_type: string;
    abp: string;
    funding_source: string;
    spf: string;
    code_gu: string;
    period: string;
    unit: string;
    report_name: string;
    bik: string;
    iik: string;
    year_beginning_balance: number;
    opening_balance: number;
    closing_balance: number;
    region_code: string;
    budget_type_code: string;
    funding_source_code: string;
    prev_period: number;
}


@Component({
    components: {JournalTable}
})

export default class PdfLoader520 extends Vue {
    @Prop({type: Object, required: true}) propData!: Report520;
    @Prop({type: [], required: true}) fileBody!: [];
    @Prop({type: String}) fileName!: string;
    @Prop({type: File}) file!: File | null;

    light: string = "light";
    fields = [
        {key: "transact_nom", label: "No транзакции", sortable: false},
        {key: "bik", label: "БИК", sortable: false},
        {key: "iik", label: "ИИК", sortable: false},
        {key: "debit", label: "Дебет", sortable: false},
        {key: "credit", label: "Кредит", sortable: false},
    ];

    get userLogin(): string {
        return this.$store.state.user.login;
    }

    async CheckHash(): Promise<void> {
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        try {
            const response = await fetch("/api-py/check-hash", {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result === true) {
                this.handleOk();
            } else {
                this.on520Load(formData);
            }
        } catch (error) {
            console.error("Error checking hash:", error);
        }
    }

    handleOk(): void {
        if (!this.file || !this.fileName) return;

        const formData = new FormData();
        formData.append("file", this.file, this.fileName);

        this.$bvModal
            .msgBoxConfirm("Сохранение приведет к изменению ранее принятых данных", {
                title: "Подтвердите",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Сохранить",
                cancelTitle: "Отменить",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true
            })
            .then((value: boolean) => {
                console.log("Save", value);
                if (value) {
                    this.on520Load(formData);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    get is_prev_period_valid(): boolean {
        const data = this.propData;
        if (!data) return true;
        if (data.prev_period?.toString() == "") return true;
        const prev = data.prev_period?.toString();
        if (prev?.startsWith("Нет")) return true;

        const opening = parseFloat(data.opening_balance?.toString() || "NaN");
        const prevNum = parseFloat(prev || "NaN");

        return !isNaN(prevNum) && !isNaN(opening) && prevNum === opening;
    }

    get is_legal_unit(): boolean {
        const data = this.propData;
        if (!data) return true;
        if (data.unit == "") return true;
        const unit = data.unit?.toString();
        if (unit?.toLowerCase().startsWith("тенге")) return true;
        return false
    }

    closing = 0;
    calc_closing = 0;

    get is_balanced() {
        let credit = 0;
        let debit = 0;
        const floatEquals = (a: number, b: number, tolerance = 0.0001) => Math.abs(a - b) < tolerance;
        if (this.fileBody.length==0) return true;
        if (Array.isArray(this.fileBody)) {
            if (this.fileBody.length > 0) {
                for (const item of this.fileBody) {
                    credit = credit + parseFloat(item["credit"]);
                    debit = debit + parseFloat(item["debit"]);
                }
            }
        }
        if (this.propData) {
            const opening = parseFloat(this.propData?.opening_balance.toString());
            const closeing = parseFloat(this.propData?.closing_balance.toString());
            const calc_closing = opening + debit - credit
            this.closing = closeing;
            this.calc_closing = calc_closing;
            return floatEquals(closeing, calc_closing);
        }
        return false;
    }


    on520Load(formData: FormData): void {
        const user = this.userLogin;
        this.$emit("save-load520", true);

        Ax({
            url: `/api-py/save-b520/${user}`,
            method: "POST",
            data: formData
        }, data => {
            console.debug("Data", data)
        });

        this.makeToast("success", "Загрузка файла начата! Результат в журнале Загрузки", "Результат");
        this.$emit("save-load520", false);
    }

    onClear(): void {

        this.$emit("form-clear520", []);
        // if (this.propData) {
        //     this.propData = null
        // }
    }

    makeToast(variant: string, tostbody: string, title: string): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 2000,
            solid: true
        });
    }

    keyEvent(event: KeyboardEvent): void {
        // Обработчик событий клавиатуры (пока пуст)
    }
}

